import React from 'react';

// Línea bajo el mensaje propio con el estado del correo de aviso. Los campos
// los escribe el hilo de envío en el back (correosTotal/Enviados/Fallidos,
// estadoCorreo). Mensajes antiguos no los traen y no muestran nada.
export default function EstadoCorreo({ mensaje, reenviando, onReenviar }) {
  const estado = mensaje.estadoCorreo;
  if (!estado) {
    return null;
  }
  const total = mensaje.correosTotal || 0;
  const enviados = mensaje.correosEnviados || 0;
  const fallidos = mensaje.correosFallidos || 0;

  if (reenviando) {
    return (
      <div className="chat-estado chat-estado-enviando">
        <span className="chat-estado-ic"></span>Reenviando…
      </div>
    );
  }
  if (estado === 'enviando') {
    return (
      <div className="chat-estado chat-estado-enviando">
        <span className="chat-estado-ic"></span>Enviando correo… {enviados} de {total}
      </div>
    );
  }
  if (estado === 'fallido') {
    return (
      <div className="chat-estado chat-estado-fallido">
        <span className="chat-estado-ic"></span>No llegó a {fallidos} de {total} proveedores
        <button type="button" className="chat-reenviar" onClick={() => onReenviar(mensaje.identificador)}>
          Reenviar
        </button>
      </div>
    );
  }
  return (
    <div className="chat-estado chat-estado-enviado">
      <span className="chat-estado-ic"></span>Correo enviado a {enviados} proveedores
    </div>
  );
}
